module.exports = __webpack_public_path__ + "media/Tapping Invite Button.f699cc3e.mp3";